import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {AuthenticationService} from "../../../_services/authentication.service";
import {UserService} from "../../../_services/user.service";
import {Observable} from "rxjs/Observable";
import {Response} from "@angular/http";
import {DialogService} from "ng2-bootstrap-modal";
import {ChangeProfileComponent} from "./change-profile/change-profile.component";
import {ChangeModuleComponent} from "./change-module/change-module.component";
import {ShowModulesComponent} from '../../register/show-modules/show-modules.component';

@Component({
    selector: 'app-profile-user',
    templateUrl: './profile-user.component.html',
    styleUrls: ['./change-profile.component.css'],
    encapsulation: ViewEncapsulation.None
})

export class ProfileUserComponent implements OnInit {

    private imageAvatar: any;
    aboutUser: Observable<any[]>;
    aboutUserConnectLine: Observable<any[]>;
    lineBots: Observable<any[]>;
    telegram: Observable<any[]>;
    public isProfileAdmin: any = false;
    public cmdConnect: any = String;
    public existConnect: any = false;
    public isActiveModule: any = false;
    public moduleId: any = false;

    constructor(private dialogService: DialogService,
                private authenticationService: AuthenticationService,
                private userService: UserService) {
        this.imageAvatar = this.authenticationService.getFieldUserCurrent('imgAvatar');
        this.isProfileAdmin = this.authenticationService.checkRoleUser().isAdmin;
    }

    ngOnInit() {
        this.getProfileUser();
    }

    getProfileUser() {
        let self = this;
        self.userService.getProfileUser({})
            .subscribe((response: Response) => {
                    let result = response.json();
                    if (result.hasOwnProperty('type') && result.type == '_SUCCESS_') {
                        if (result.hasOwnProperty('data')) {
                            let resData = result.data;
                            // about information user
                            self.aboutUser = resData.about;
                            self.lineBots = resData.dataLineBot;
                            self.telegram = resData.dataTelegram;
                            self.isActiveModule = resData.isActiveModule;
                            self.moduleId = resData.moduleId;
                            if (resData.about.hasOwnProperty('imgAvatar') && resData.about.imgAvatar) {
                                self.imageAvatar = resData.about.imgAvatar;
                            }
                            if (resData.about.hasOwnProperty('cmdConnect') && resData.about.cmdConnect) {
                                self.cmdConnect = resData.about.cmdConnect;
                            }
                            if (resData.about.hasOwnProperty('isAdmin')) {
                                if (resData.about.isAdmin) {
                                    self.isProfileAdmin = resData.about.isAdmin;
                                } else {
                                    // user connect line bot
                                    self.existConnect = resData.userConnectLine.existConnect;
                                    if (resData.userConnectLine.hasOwnProperty('listConnects')) {
                                        //exist user connect line bot
                                        self.aboutUserConnectLine = resData.userConnectLine.listConnects;
                                    }
                                }
                            }
                        }
                    }
                }, error => {
                    console.log(error)
                }
            );
    }

    openModalEditPwd() {
        let self = this;
        this.dialogService.addDialog(ChangeProfileComponent)
            .subscribe((isAccess) => {
                if(isAccess) {

                }
            });
    }

    openModalChangeModule() {
        this.dialogService.addDialog(ChangeModuleComponent);
    }

    openModalAddMail() {
        this.dialogService.addDialog(ShowModulesComponent);
    }
}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/user/profile-user/profile-user.component.ts